import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Table from "./pages/Table";
import AuthLayout from "./components/Layout/AuthLayout";
import GuestLayout from "./components/Layout/GuestLayout";
import Login from "./pages/auth/Login";
import Blank from "./pages/Blank";
import NotFound from "./pages/NotFound";
import Form from "./pages/Form";
import RenalTable from "./pages/rft/RFTTable";
import VaccinationTable from "./pages/vaccinations/VaccinationTable";
import DiagnosisTable from "./pages/diagnosis/DiagnosisTable";
import Footer from "./components/Footer";
import RenalScreening from "./pages/screening/ScreeningTable";
import ScreeningDetails from "./pages/AppServices/Patient.Details";
import RenalMonitoring from "./pages/monitoring/MonitoringTable";
import UserActivity from "./pages/ChpActivity/user.activity";
import NafsUserActivity from "./pages/NafsChpActivity/nafsuser.activity";
import { useAuth } from "./context/AuthContext";
import AntenatalTable from "./pages/antenatal/AntenantalTable";
import Chat from "./components/Other/ChatFeature";
import Notifications from "./components/Other/Notification.Table";
import SimprintsPage from "./pages/simprints/SimprintsPage";
import MityanaPage from "./pages/mityana/MityanaPage";
import Portfolio from "./pages/Portfolio";
function App() {
  const { isLoggedIn, userRole } = useAuth();

  const renderDashboardRoute = () => {
    // Check if user is logged in and their role is not "Authenticated"
    if (isLoggedIn && userRole !== "Authenticated") {
      return <Route path="/dashboard" element={<Dashboard />} />;
    } else {
      return (
        <Route
          path="/dashboard"
          element={<Navigate to="/need-access" replace />}
        />
      );
    }
  };
  return (
    <div>
      <Routes>
        <Route path="/auth" element={<GuestLayout />}>
          <Route path="/auth/login" element={<Login />}></Route>
          {/* <Route path="/auth/register" element={<RegisterIndex />}></Route> */}
        </Route>
        <Route path="/portfolio" element={<Portfolio />}></Route>
        <Route
          path="/"
          element={
            isLoggedIn ? <Navigate replace to="/dashboard" /> : <Navigate replace to="/auth/login" />
          }
        >
        </Route>
        <Route
          path="/"
          element={
            isLoggedIn ? <AuthLayout /> : <Navigate replace to="/auth/login" />
          }
        >
          <Route path="dashboard" element={<Dashboard />}></Route>
          <Route path="chat" element={<Chat />}></Route>
          <Route path="notifcations" element={<Notifications />}></Route>
          <Route path="table" element={<Table />}></Route>
          <Route path="renal" element={<RenalTable />}></Route>
          <Route path="vaccination" element={<VaccinationTable />}></Route>
          <Route path="diagnosis" element={<DiagnosisTable />}></Route>
          <Route path="antenantal" element={<AntenatalTable />}></Route>
          <Route path="screening" element={<RenalScreening />}></Route>
          <Route
            path="patient/:patientId"
            element={<ScreeningDetails />}
          ></Route>
          <Route path="monitoring" element={<RenalMonitoring />}></Route>
          <Route path="chpactivity" element={<UserActivity />}></Route>
          <Route path="nafschpactivity" element={<NafsUserActivity />}></Route>
          <Route path="simprints" element={<SimprintsPage />}></Route>
          <Route path="mityana" element={<MityanaPage />}></Route>
        
          <Route path="blank" element={<Blank />}></Route>
          <Route path="404" element={<NotFound />}></Route>
          <Route path="form" element={<Form />}></Route>
          <Route path="profile" element={<Blank />}></Route>
        </Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
